import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { authService } from "../services/AuthServices";
import iconimg from "../assets/header_logo.png";
import welcomeImg from "../assets/welcome.jpg";
import { googleAuthService } from "../services/GoogleAuthService";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message);
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const data = {
        email: email,
        password: password,
      };
      const response = await authService.login(data);
      if (response.status === 200) {
        toast.success(response.message);
        const userData = response.data.data;
        const jsonString = JSON.stringify(userData);
        const encodedData = encodeURIComponent(jsonString);

        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", encodedData);
        localStorage.setItem("id", response.data.data._id);
        navigate("/user/dashboard");
      } else {
        toast.error(response.message);
        setError(response.message);
      }
    } catch (err) {
      setError("Invalid credentials");
      toast.error("Invalid credentials");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setIsGoogleLoading(true);
    setError("");

    try {
      const result = await googleAuthService.signInWithGoogle();

      if (result.success) {
        // Option 1: Send to your backend (recommended)
        const googleUserData = {
          email: result.user.email,
          name: result.user.displayName,
        };

        const response = await authService.authUser(googleUserData);
        if (response.status === 200) {
          const userData = response.data.data;
          const jsonString = JSON.stringify(userData);
          const encodedData = encodeURIComponent(jsonString);

          localStorage.setItem("token", response.data.token);
          localStorage.setItem("user", encodedData);
          localStorage.setItem("id", response.data.data._id);

          toast.success("Successfully signed in with Google!");
          navigate("/user/dashboard");
        } else {
          toast.error("Internal Server Error");
        }
      } else {
        setError(result.error);
        toast.error(result.error);
      }
    } catch (error) {
      setError("Google sign-in failed");
      toast.error("Google sign-in failed");
    } finally {
      setIsGoogleLoading(false);
    }
  };

  return (
    <>
      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        html,
        body {
          height: 100%;
          overflow-x: hidden;
        }

        #cryptoon-layout {
          min-height: 100vh;
          height: 100%;
          background: linear-gradient(
            135deg,
            #ffffff 0%,
            #f8f9fa 100%
          ) !important;
          position: relative;
          overflow: hidden;
        }

        .auth-container {
          min-height: 100vh;
          height: 100%;
          background: transparent;
          position: relative;
          overflow: hidden;
        }

        #cryptoon-layout::before {
          content: "";
          position: absolute;
          top: -50%;
          right: -50%;
          width: 100%;
          height: 100%;
          background: radial-gradient(
            circle,
            rgba(255, 193, 7, 0.1) 0%,
            transparent 70%
          );
          transform: rotate(45deg);
          z-index: 0;
        }

        .main-content {
          position: relative;
          z-index: 1;
        }

        .logo-container {
          transition: all 0.3s ease;
        }

        .logo-container:hover {
          transform: scale(1.05);
        }

        .logo-img {
          filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
          transition: all 0.3s ease;
        }

        .auth-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 193, 7, 0.2);
          border-radius: 20px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          overflow: hidden;
          position: relative;
        }

        .auth-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #ffc107, #ffeb3b, #ffc107);
          background-size: 200% 100%;
          animation: shimmer 2s infinite;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        .auth-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
        }

        .welcome-text {
          background: linear-gradient(135deg, #333, #666);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 700;
        }

        .subtitle-text {
          color: #6c757d;
          font-weight: 400;
          line-height: 1.6;
        }

        .form-floating {
          position: relative;
        }

        .form-control {
          border: 2px solid #e9ecef;
          border-radius: 12px;
          padding: 12px 16px;
          font-size: 16px;
          transition: all 0.3s ease;
          background: rgba(255, 255, 255, 0.8);
        }

        .form-control:focus {
          border-color: #ffc107;
          box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);
          background: #fff;
          transform: translateY(-2px);
        }

        .form-label {
          font-weight: 600;
          color: #495057;
          margin-bottom: 8px;
        }

        .password-toggle {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: #6c757d;
          cursor: pointer;
          padding: 4px;
          border-radius: 4px;
          transition: all 0.2s ease;
        }

        .password-toggle:hover {
          color: #ffc107;
          background: rgba(255, 193, 7, 0.1);
        }

        .btn-login {
          background: linear-gradient(135deg, #ffc107, #ffed4e);
          border: none;
          border-radius: 12px;
          padding: 14px 24px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .btn-login::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.3),
            transparent
          );
          transition: left 0.5s;
        }

        .btn-login:hover::before {
          left: 100%;
        }

        .btn-login:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(255, 193, 7, 0.4);
          background: linear-gradient(135deg, #ffcd39, #fff176);
        }

        .btn-login:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .btn-google {
          background: #fff;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          padding: 14px 24px;
          font-weight: 600;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          color: #495057;
        }

        .btn-google:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          border-color: #4285f4;
          color: #4285f4;
        }

        .btn-google:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .divider {
          display: flex;
          align-items: center;
          text-align: center;
          margin: 24px 0;
        }

        .divider::before,
        .divider::after {
          content: "";
          flex: 1;
          height: 1px;
          background: #e9ecef;
        }

        .divider span {
          padding: 0 16px;
          color: #6c757d;
          font-size: 14px;
          font-weight: 500;
        }

        .spinner {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 2px solid #ffffff;
          border-radius: 50%;
          border-top-color: transparent;
          animation: spin 1s ease-in-out infinite;
        }

        .spinner-google {
          border-color: #4285f4;
          border-top-color: transparent;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        .forgot-link,
        .register-link {
          color: #ffc107 !important;
          text-decoration: none !important;
          font-weight: 500;
          transition: all 0.2s ease;
          position: relative;
        }

        .forgot-link::after,
        .register-link::after {
          content: "";
          position: absolute;
          width: 0;
          height: 2px;
          bottom: -2px;
          left: 0;
          background-color: #ffc107;
          transition: width 0.3s ease;
        }

        .forgot-link:hover::after,
        .register-link:hover::after {
          width: 100%;
        }

        .forgot-link:hover,
        .register-link:hover {
          color: #ffcd39 !important;
          transform: translateY(-1px);
        }

        .error-message {
          background: #fff5f5;
          border: 1px solid #fed7d7;
          color: #c53030;
          padding: 12px 16px;
          border-radius: 8px;
          margin-top: 16px;
          font-size: 14px;
          animation: slideIn 0.3s ease;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .welcome-image {
          border-radius: 20px;
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .welcome-image:hover {
          transform: scale(1.02) rotate(1deg);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }

        .bottom-links {
          margin-top: 24px;
          padding-top: 24px;
          border-top: 1px solid #e9ecef;
        }

        @media (max-width: 768px) {
          .auth-card {
            margin: 20px;
            border-radius: 16px;
          }

          .welcome-text {
            font-size: 1.75rem;
          }
        }

        .input-group {
          position: relative;
        }

        .google-icon {
          width: 20px;
          height: 20px;
          margin-right: 12px;
        }
      `}</style>

      <div id="cryptoon-layout" className="theme-orange">
        <div className="auth-container">
          <div
            className="main-content p-2 py-3 p-xl-5"
            style={{ minHeight: "100vh" }}
          >
            <div className="container-xxl">
              <div className="row align-items-center mb-4">
                <div className="col">
                  <Link
                    to="/"
                    className="logo-container d-flex align-items-center"
                  >
                    <img
                      src={iconimg}
                      width={100}
                      className="logo-img"
                      alt="Logo"
                    />
                  </Link>
                </div>
              </div>
            </div>

            <div
              className="body d-flex p-0 p-xl-5"
              style={{ minHeight: "calc(100vh - 140px)" }}
            >
              <div className="container-xxl h-100">
                <div className="row g-4 align-items-center h-100">
                  <div className="col-lg-6 d-flex justify-content-center align-items-center">
                    <div className="w-100" style={{ maxWidth: "480px" }}>
                      <div className="text-center mb-4">
                        <h1 className="welcome-text mb-3">Account Login</h1>
                        <p className="subtitle-text">
                          Welcome back! Fill in your credentials to access your
                          dashboard.
                        </p>
                      </div>

                      <div className="auth-card">
                        <div className="card-body p-4 p-md-5">
                          {/* Google Sign In Button */}
                          <button
                            type="button"
                            className="btn btn-google w-100 py-3 mb-3"
                            onClick={handleGoogleSignIn}
                            disabled={isGoogleLoading}
                          >
                            {isGoogleLoading ? (
                              <>
                                <span className="spinner spinner-google me-2"></span>
                                Signing in with Google...
                              </>
                            ) : (
                              <>
                                <svg
                                  className="google-icon"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="#4285F4"
                                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                  />
                                  <path
                                    fill="#34A853"
                                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                  />
                                  <path
                                    fill="#FBBC05"
                                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                  />
                                  <path
                                    fill="#EA4335"
                                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                  />
                                </svg>
                                Continue with Google
                              </>
                            )}
                          </button>

                          <div className="divider">
                            <span>OR</span>
                          </div>
                          <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                              <label className="form-label">
                                Email Address
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                              />
                            </div>

                            <div className="mb-4">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <label className="form-label">Password</label>
                                <Link
                                  to="/forgot-password"
                                  className="forgot-link text-sm"
                                >
                                  Forgot Password?
                                </Link>
                              </div>
                              <div className="input-group">
                                <input
                                  type={showPassword ? "text" : "password"}
                                  className="form-control"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  placeholder="Enter your password"
                                  required
                                />
                                <button
                                  type="button"
                                  className="password-toggle"
                                  onClick={() => setShowPassword(!showPassword)}
                                >
                                  {showPassword ? (
                                    <svg
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.708zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                    </svg>
                                  ) : (
                                    <svg
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                    </svg>
                                  )}
                                </button>
                              </div>
                            </div>

                            <button
                              type="submit"
                              className="btn btn-login w-100 py-3"
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <>
                                  <span className="spinner me-2"></span>
                                  Signing In...
                                </>
                              ) : (
                                "Log In"
                              )}
                            </button>
                          </form>

                          {error && (
                            <div className="error-message">
                              <strong>Error:</strong> {error}
                            </div>
                          )}

                          <div className="bottom-links text-center">
                            <p className="mb-0 text-muted">
                              Don't have an account?{" "}
                              <Link to="/user/signup" className="register-link">
                                Register now
                              </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 d-none d-lg-flex justify-content-center align-items-center">
                    <div className="text-center">
                      <img
                        src={welcomeImg}
                        alt="Welcome"
                        className="welcome-image img-fluid"
                        style={{ maxWidth: "400px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;
